import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SwiperModule } from 'ngx-swiper-wrapper';

import { TrendingCategoriesContainerComponent } from './components/trending-categories-container/trending-categories-container.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [TrendingCategoriesContainerComponent],
  imports: [CommonModule, SwiperModule, RouterModule],
  exports: [TrendingCategoriesContainerComponent],
})
export class TrendingCategoriesModule {}
